import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, Injector, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommandButtonModule } from 'ui-components/button';
import { EventData, HttpService, StatusService } from 'ui-components/common';
import { DomHandler } from 'ui-components/dom';
import { MessagesModule } from 'ui-components/messages';
import { PopupModule } from 'ui-components/popup';
import { ValidatorService } from 'ui-components/validator';
import { environment } from '../environments/environment';
import { GibErrorCode } from './com/ibm/tw/commons/core/exception/ext/gib.error.code';
import { ErrorStatus } from './com/ibm/tw/commons/status/error.status';
import { BrowserUtils } from './com/ibm/tw/commons/utils/browser.utils';
import { E2eUtils } from './com/ibm/tw/commons/utils/e2e.utils';
import { SoftTokenTxVerifyPopupComponent } from './pagecode/commonpage/softtokentxverifypopup/softtoken.tx.verify.popup.component';
import { SoftTokenTxVerifyPopupViewForm } from './pagecode/commonpage/softtokentxverifypopup/softtoken.tx.verify.popup.viewfrom';
import { SuspendPopupComponent } from './pagecode/commonpage/suspend/suspend.popup.component';
import { SuspendPopupViewForm } from './pagecode/commonpage/suspend/suspend.popup.viewfrom';
import { AxthenticationService, ShareService } from './services';
import { TxnService } from './services/txn.service';

@Component({
    selector: 'GIB-App',
    encapsulation: ViewEncapsulation.None,
    templateUrl: 'app.component.html',
    standalone: true,
    imports: [RouterOutlet, SoftTokenTxVerifyPopupComponent, CommandButtonModule, PopupModule,
        SuspendPopupComponent, CommonModule, MessagesModule],
    providers: [DomHandler, ValidatorService]
})
export class AppComponent implements OnInit, OnDestroy {


    /** 初始化多國語系. */
    commonJS: string = '/inc/json/zhTW/common.js';

    subscription: Subscription;

    routerSubscription: Subscription;

    display: boolean = false;

    /** 系統Dialog */
    systemDisplay: boolean = false;

    /** 系統暫停Dialog */
    suspendDisplay: boolean = false;

    /** SoftToken交易驗證Dialog */
    softTokenTxVerifyDisplay: boolean = false;

    suspendTimer: any;

    /** SoftToken Tx Verify Timer */
    softTokenTxVerifyTimer: any;

    /** 系統訊息 */
    systemMessage: String;

    suspendViewForm: SuspendPopupViewForm = new SuspendPopupViewForm();

    /** SoftToken交易驗證 popup viewForm */
    softTokenTxVerifyViewForm: SoftTokenTxVerifyPopupViewForm = new SoftTokenTxVerifyPopupViewForm();

    /** 是否是後踏前造成的popup訊息 */
    isServerTimeout: boolean = false;

    /** Popup訊息的確定按鈕顯示名稱 */
    systemButtonName: string;

    /** 系統提示訊息的Popup */
    systemPopupTitle: string = '';

    /** 系統提示訊息的Label */
    systemPopupLabel: string = '';

    /** 系統提示訊息的Popup width */
    systemPopupWidth: string = '700';

    /** 系統提示訊息的Popup height */
    systemPopupHeight: string = '300';

    /** 系統提示訊息的Popup conent height */
    systemPopupContentHeight: string = '280';

    mask: HTMLDivElement | null = null;

    maskId: string;

    @ViewChild('loadingContainer') loadingContainer: ElementRef;

    private createdCssRules: string[] = [];

    constructor(
        private http: HttpService,
        public statusService: StatusService,
        protected shareService: ShareService,
        public axthenticationService: AxthenticationService,
        protected injector: Injector,
        protected router: Router,
        public domHandler: DomHandler,
        public txnService: TxnService,
        private meta: Meta
    ) {
        if (!this.verifyBrowser()) {
            return;
        }

        this.statusService.injector = injector;
        this.http.server = environment.twServer;

        E2eUtils.txnService = this.txnService;

        if (!BrowserUtils.isMobile()) {

            let viewport: HTMLMetaElement | null = this.meta.getTag('name=viewport');

            if (viewport) {
                this.meta.removeTagElement(viewport);
            }

        }

        let lang = this.txnService.getLocaleStorageValue();

        this.commonJS = '/inc/json/' + lang.replace('_', '') + '/common.js';

        this.commonJS += '?seq=' + environment.cacheValue;

        this.shareService.langService.currentLang = lang;

    }

    /**
     * 確認使用者的裝置是否為iphone/ipad/ipod
     * @returns 
     */
    private verifyBrowser(): boolean {
        //導頁
        let arys = navigator.userAgent.match(/iPhone|iPad|iPod/i);
        if (arys != null) {
            if (window.top.location.href.indexOf('/mindex.html') > -1) {
                return true;
            }
            window.top.location.href = './mindex.html';
            return false;
        }

        return true;
    }

    public closePopup(): void {
        this.statusService.hide();
    }

    ngOnDestroy() {
        try {
            // prevent memory leak when component destroyed
            this.subscription.unsubscribe();
            this.routerSubscription.unsubscribe();
            this.domHandler.cleanupDynamicCssRules('app-component', this.createdCssRules);
        } catch (e) { }
    }

    public ngOnInit() {

        this.statusService.injector = this.injector;

        this.txnService.insertLangCommonLanguage(this.afterInsertLang.bind(this));

        // GIB-6100 外部滲透建議生產環境不可有console.log或是需進行加密，依據environment.envModle設定如環境是uat、stage、prod則將console.log導向空函式。
        if (environment.envModule == 'uat' || environment.envModule == 'stg' || environment.envModule == 'prod') {
            console.log = () => { };
        }
    }

    afterInsertLang() {

        // 換頁之後，要將畫面捲到最上面.
        this.routerSubscription = this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });

        // this.display = this.statusPopupService.display;
        this.subscription = this.statusService.showStatusSource$.subscribe(
            showStatus => {

                //  先取得預設的標題
                if (this.display) {
                    setTimeout(() => {
                        this.systemPopupTitle = this.txnService.transform('系統訊息', 'common00004716', null);
                        this.systemPopupLabel = this.txnService.transform('警告', 'common00000778', null);
                    }, 0);
                }

                if (showStatus !== 'show' && showStatus !== 'hide') {
                    // 當不是系統處理中的loading圖示時，重設寬度.
                    setTimeout(() => {
                        this.systemPopupWidth = '800';
                        this.systemPopupHeight = '300';
                        this.systemPopupTitle = this.txnService.transform('系統訊息', 'common00004716', null);
                        this.systemButtonName = this.txnService.transform('確定', 'Confirm', null);
                    }, 0);
                }

                if ((showStatus === undefined)) {
                } else if (showStatus === 'show') {
                    setTimeout(() => {
                        if (!this.display) {
                            this.enableModality();
                        }
                    }, 200);
                } else if (showStatus === 'hide') {
                    setTimeout(() => {
                        if (this.display) {
                            this.disableModality();
                        }
                    }, 200);
                } else if (showStatus === GibErrorCode.SOFTTOKEN_TX_VERIFY_TIMEOUT) {
                    //  console.log('不做事，實際的程式在B2cMultiConfirmComponent及B2cConfirmComponent => ' + showStatus);
                } else if (showStatus === GibErrorCode.SERVER_TIMEOUT || showStatus.indexOf('TIMEOUT') > -1) {
                    if (this.axthenticationService.isLoggedIn) {
                        setTimeout(() => {
                            this.isServerTimeout = true;
                            this.systemMessage = this.txnService.transform('連線失敗，請重新登入。', 'common01050001', null);
                            this.systemDisplay = true;
                            this.systemButtonName = this.txnService.transform('重新登入', 'common00005497', null);
                        }, 0);
                    }
                    // } else if (showStatus === GibErrorCode.LOGIN_GIB_SUSPEND) {
                    //    // console.log('LOGIN_GIB_SUSPEND....');
                    //    this.doSystemSuspendPopup();
                } else if (showStatus === GibErrorCode.SERVER_FORCELOGOUT || showStatus.indexOf('FORCELOGOUT') > -1) {
                    // GIB-4872 強制登出與TIMEOUT拆開
                    if (this.axthenticationService.isLoggedIn) {
                        setTimeout(() => {
                            this.isServerTimeout = true;
                            this.systemMessage = this.txnService.transform('目前使用者已於其他地方登入本系統，您即將被登出本系統。', 'common00002017', null);
                            this.systemDisplay = true;
                            this.systemButtonName = this.txnService.transform('重新登入', 'common00005497', null);
                        }, 0);
                    }
                }
                else if (showStatus === GibErrorCode.SYSTEM_SUSPEND) {


                    let err: ErrorStatus = this.txnService.getShareService().getAppParam('error') as ErrorStatus;

                    this.suspendViewForm.timeout = this.axthenticationService.suspendViewForm.timeout;

                    if (this.suspendViewForm.timeout !== -1) {
                        this.suspendViewForm.errorDesc = this.axthenticationService.suspendViewForm.errorDesc;
                    }

                    if (this.suspendViewForm.timeout > 0) {
                        this.suspendDisplay = true;

                        // 先將舊的清除，然後再啟新的timer
                        clearInterval(this.suspendTimer);

                        this.suspendTimer = setInterval(() => {

                            this.suspendViewForm.timeout = this.suspendViewForm.timeout - 1;
                            if (this.suspendViewForm.timeout === 0) {
                                clearInterval(this.suspendTimer);
                                this.suspendViewForm.timeout = -1;
                                this.suspendDisplay = false;
                                this.axthenticationService.logout();
                            }
                        }, 1000);
                    } else {
                        this.doSystemSuspendPopup();
                    }


                } else if (showStatus === GibErrorCode.SOFTTOKEN_TX_VERIFY) {

                    this.softTokenTxVerifyViewForm.timeout = this.axthenticationService.softTokenTxVerifyViewForm.timeout;

                    this.softTokenTxVerifyViewForm.userDeviceName = this.axthenticationService.softTokenTxVerifyViewForm.userDeviceName;
                    this.softTokenTxVerifyViewForm.txFlag = this.axthenticationService.softTokenTxVerifyViewForm.txFlag;

                    if (this.softTokenTxVerifyViewForm.timeout > 0) {
                        this.softTokenTxVerifyDisplay = true;

                        // 先將舊的清除，然後再啟新的timer
                        clearInterval(this.softTokenTxVerifyTimer);

                        this.softTokenTxVerifyTimer = setInterval(() => {

                            this.softTokenTxVerifyViewForm.timeout = this.softTokenTxVerifyViewForm.timeout - 1;
                            if (this.softTokenTxVerifyViewForm.timeout === 0) {
                                this.closeSoftTokenVerifyPopup();
                                this.statusService.addMsg(GibErrorCode.SOFTTOKEN_TX_VERIFY_TIMEOUT);
                            }
                        }, 1000);
                    }

                } else if (showStatus === 'GibSuspendClose') {
                    clearInterval(this.suspendTimer);
                } else if (showStatus === GibErrorCode.CLOSE_SOFTTOKEN_TX_VERIFY) {
                    this.closeSoftTokenVerifyPopup();
                } else if (showStatus === GibErrorCode.SOFTTOKEN_TX_CANCEL_VERIFY) {
                    this.closeSoftTokenVerifyPopup();
                } else if (showStatus === GibErrorCode.CLOSE_SOFTTOKEN_FOR_FLOWACTION) {
                    this.closeSoftTokenVerifyPopup();
                    setTimeout(() => {
                        if (!this.display) {
                            this.enableModality();
                        }
                    }, 200);
                } else {
                    if (showStatus !== undefined) {
                        if (showStatus !== '') {
                            setTimeout(() => {
                                this.systemMessage = showStatus;
                                this.systemDisplay = true;
                            }, 0);
                        }
                    }
                }

                setTimeout(() => {
                    this.systemPopupContentHeight = String(parseInt(this.systemPopupHeight, 10) - 20);
                }, 0);
                // console.log('showStatus end..' + showStatus + ',,,' + this.systemPopupWidth
                // + ',,' + this.systemPopupContentHeight);

                this.removeModalOpen(showStatus);
                setTimeout(() => {
                    this.removeModalOpen(showStatus);
                }, 300);
            });
    }

    /**
     * close SoftToken Verify Popup
     */
    private closeSoftTokenVerifyPopup() {
        clearInterval(this.softTokenTxVerifyTimer);
        this.softTokenTxVerifyViewForm.timeout = -1;
        this.softTokenTxVerifyDisplay = false;
    }

    /**
     * enable modality
     */
    enableModality() {
        this.display = true;
        if (this.loadingContainer) {
            this.domHandler.setDynamicZIndex(this.loadingContainer.nativeElement, DomHandler.zindex + 10,
                'app-component', this.createdCssRules);
        }
        if (!this.mask) {
            this.mask = document.createElement('div');
            this.domHandler.setDynamicZIndex(this.mask, DomHandler.zindex + 9,
                'app-component', this.createdCssRules);
            this.maskId = 'system_maskId_' + String(Math.random());
            this.mask.id = this.maskId;
            this.domHandler.addMultipleClasses(this.mask, 'ui-widget-overlay ui-dialog-mask');
            document.body.appendChild(this.mask);
        }

    }

    /**
     * disable modality
     */
    disableModality() {

        try {
            if (this.mask) {
                document.body.removeChild(this.mask);
                this.mask = null;
            }

            this.display = false;
        } catch (e) {
        }
    }
    /**
     * 處理系統暫停的訊息
     */
    doSystemSuspendPopup(): void {
        // let pinText: HTMLInputElement = document.body.querySelector('#pinText');
        // if (pinText != null) {
        //    pinText.readOnly = false;
        // }
        setTimeout(() => {
            this.isServerTimeout = false;
            this.systemButtonName = this.txnService.transform('確定', 'Confirm', null);

            if (this.axthenticationService.isLoggedIn) {
                this.isServerTimeout = true;
                this.systemButtonName = this.txnService.transform('現在登出', 'common00001352', null);
            }

            let err: ErrorStatus = this.txnService.getAppParam('error') as ErrorStatus;
            this.systemMessage = err.errorDesc + ' [' + err.errorCode + ']'
            this.systemPopupTitle = this.txnService.transform('系統維護暫停登入', 'common00000014', null);
            // console.log(' this.systemPopupTitle==' + this.systemPopupTitle);
            this.systemDisplay = true;
            this.systemPopupWidth = '500';
            this.systemPopupHeight = '200';
            // console.log('suspendViewForm...', this.suspendViewForm);
        }, 0);
    }

    removeModalOpen(showStatus: any) {
        let doms = this.domHandler.find(document.body, '.puidialog');
        let popupCount = 0;
        for (let i = 0; i < doms.length; i++) {
            // CSP-compliant: Check visibility using CSS class only
            if (doms[i].classList.contains('display-block') &&
                !doms[i].classList.contains('display-none')) {
                popupCount++;
            }
        }
        // // console.log('popupCount=' , showStatus , popupCount , ',className=' ,
        // document.body.className, (popupCount === 0), 'doms.length=', doms.length );
        if (popupCount === 0) {
            // // console.log('contains...'+  this.domHandler.hasClass(document.body, 'modal-open'));
            if (this.domHandler.hasClass(document.body, 'modal-open')) {
                this.domHandler.removeClass(document.body, 'modal-open');
            }

        }
    }

    closeSystemPopup() {
        this.systemDisplay = false;
        if (this.isServerTimeout) {
            // console.log('將使用者登出...');
            this.statusService.show();
            this.axthenticationService.logout();
        }
    }

    /**
     * 系統暫停，繼續使用
     */
    closeCallback(event: EventData) {
        if (this.suspendDisplay) {
            this.suspendDisplay = false;
        }

    }

    /**
     * 系統暫停，進行登出
     * @param event
     */
    confirmCallback(event: EventData) {
        clearInterval(this.suspendTimer);
        this.suspendViewForm.timeout = -10000;
        if (this.suspendDisplay) {
            this.suspendDisplay = false;
        }

        this.axthenticationService.logout();
    }

    /**
     * SoftToken交易驗證，繼續使用
     */
    closeSoftTokenTxVerifyCallback(event: EventData) {
        if (this.softTokenTxVerifyDisplay) {
            this.softTokenTxVerifyDisplay = false;
            this.statusService.addMsg(GibErrorCode.SOFTTOKEN_TX_CANCEL_VERIFY);
        }

    }

    onRightClick(event: Event) {
        return false;
    }


    @HostListener('window:beforeunload')
    doBeforeUnload(): void {
        // console.log('doBeforeUnload.................................');
        // this.axthenticationService.logout();
    }

}
